/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "mtgdeckanalyzerapiv1",
            "endpoint": "https://cel4kupkyf.execute-api.us-east-2.amazonaws.com/main",
            "region": "us-east-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-2:8fec9d3f-fc81-4b1c-84ee-1144384cc8e2",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_E4knooTJ3",
    "aws_user_pools_web_client_id": "5jubimc5gdtdhrbpun9iu5j2f3",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "mtgdeckanalyzer3bd94d0bc9bf43f397a29d4b60c222c512416-main",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
